module.exports = __webpack_public_path__ + "static/logo-5ed4b4dfc3a4c667e098f0ca3e7c24ab.png";